import PropTypes from 'prop-types';
import { Component } from 'react';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
export default class CheckboxInput extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = ({
      target: {
        checked
      }
    }) => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      return this.props.onChange(checked);
    };
  }
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      disabled,
      id,
      label,
      readOnly,
      value
    } = this.props;
    const inputProps = {
      'aria-label': label,
      disabled,
      id,
      onChange: this.onChange,
      readOnly,
      value
    };
    return /*#__PURE__*/_jsx(UICheckbox, Object.assign({}, inputProps));
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
CheckboxInput.propTypes = {
  disabled: PropTypes.bool,
  format: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.bool
};